import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/IGBTModulesModernElectronicsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-IGBT.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .igme { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .igme-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .igme-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .igme-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .igme-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .igme-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .igme-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .igme-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .igme-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .igme-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .igme-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .igme-bc-item:hover { color: #EB2019; }
  .igme-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .igme-bc-sep img { width: 24px; height: 24px; display: block; }
  .igme-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .igme-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .igme-main-section { padding: 80px 0 120px 0; }
  .igme-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .igme-article { flex: 1; min-width: 0; }

  .igme-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .igme-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .igme-meta-item:last-child { border-right: none; padding-right: 0; }
  .igme-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .igme-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 20px;
  }

  .igme-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .igme-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .igme-article-body p { margin-bottom: 20px; }
  .igme-article-body p:last-child { margin-bottom: 0; }

  .igme-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }
  .igme-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    margin: 0px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet ul list */
  .igme-article-body ul {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .igme-article-body ul li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .igme-article-body ul li::before {
    content: '•';
    font-weight: 700; color: #202020;
    flex-shrink: 0; font-size: 18px; line-height: 160%;
  }
  .igme-article-body ul li > span { flex: 1; }

  .igme-article-body strong { font-weight: 600; color: #202020; }

  /* Comparison table */
  .igme-table-wrapper {
    width: 100%; overflow-x: auto; margin: 20px 0 30px 0;
  }
  .igme-table {
    width: 100%; border-collapse: collapse;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; color: #202020;
  }
  .igme-table th, .igme-table td {
    border: 1px solid #B8B8B8;
    padding: 20px 30px;
    text-align: left;
    line-height: 120%;
  }
  .igme-table th {
    font-weight: 600; background: #F6F6F6;
  }
  .igme-table td { font-weight: 400; }
  
  .igme-table tbody tr:nth-child(odd)  { background-color: #ffffff; }
  .igme-table tbody tr:nth-child(even) { background-color: #F6F6F6; }

  .igme-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .igme-red-link-plain:hover { opacity: 0.8; }

  .igme-red-link {
    color: #EB2019; text-decoration: underline; font-weight: 600;
    display: inline;
  }
  .igme-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .igme-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .igme-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .igme-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .igme-nav-btn:hover { color: #EB2019; }
  .igme-nav-btn img { width: 40px; height: 40px; display: block; }

  .igme-share-icons { display: flex; align-items: center; gap: 20px; }
  .igme-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .igme-share-icon:hover { opacity: 0.85; }
  .igme-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .igme-sidebar { flex: 0 0 475px; }
  .igme-sidebar-block { margin-bottom: 60px; }
  .igme-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .igme-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .igme-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .igme-recent-item:hover .igme-recent-title { color: #EB2019; }
  .igme-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .igme-recent-body { flex: 1; min-width: 0; }
  .igme-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .igme-social-icons { display: flex; align-items: center; gap: 30px; }
  .igme-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .igme-social-icon:hover { opacity: 0.8; }
  .igme-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .igme-hero             { height: 350px; }
    .igme-hero-content     { padding: 0 32px; }
    .igme-hero-title       { font-size: 30px; }
    .igme-hero-divider     { width: 100%; max-width: 575px; }
    .igme-breadcrumb       { padding: 24px 0 0 0; }
    .igme-breadcrumb-inner { padding: 0 32px; }
    .igme-inner            { padding: 0 32px; }
    .igme-main-section     { padding: 48px 0 60px 0; }
    .igme-main-row         { flex-direction: column; gap: 48px; }
    .igme-sidebar          { flex: none; width: 100%; }
    .igme-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .igme-hero             { height: 360px; }
    .igme-hero-content     { padding: 0 16px; }
    .igme-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .igme-hero-divider     { width: 100%; }
    .igme-hero-subtitle    { font-size: 14px; }
    .igme-breadcrumb       { padding: 30px 0 0 0; }
    .igme-breadcrumb-inner { padding: 0 16px; }
    .igme-bc-item          { font-size: 14px; gap: 14px; }
    .igme-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .igme-bc-sep img       { width: 22px; height: 22px; }
    .igme-inner            { padding: 0 16px; }
    .igme-main-section     { padding: 30px 0 60px 0; }
    .igme-main-row         { flex-direction: column; gap: 60px; }
    .igme-sidebar          { flex: none; width: 100%; }
    .igme-article-title    { font-size: 20px; margin-bottom: 15px; }
    .igme-article-body     { font-size: 14px; }
    .igme-article-body p   { margin-bottom: 15px; }
    .igme-article-body ul  { margin: 20px 0 20px 0; gap: 10px; }
    .igme-article-body ul li { font-size: 14px; }
    .igme-article-body strong { font-size: 16px; }
    .igme-table            { font-size: 12px; }
    .igme-table th, .igme-table td { padding: 33px 8px;  }
    
    .igme-meta-item        { font-size: 14px; }
    .igme-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .igme-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .igme-h2               { font-size: 16px; margin: 20px 0 0px 0; }
    .igme-heading          { font-size: 16px; margin: 30px 0 15px 0; }
    .igme-nav-btn img      { width: 24px; height: 24px; }
    .igme-nav-btn          { font-size: 14px; }
    .igme-share-icon img   { width: 34px; height: 34px; }
    .igme-sidebar-title    { font-size: 20px; }
    .igme-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function IGBTModulesModernElectronics() {
  return (
    <div className="igme">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="igme-hero">
        <img className="igme-hero-bg" src={HeroBgImg} alt="IGBT Modules The Power Behind Modern Electronics Hero" />
        <div className="igme-hero-overlay" />
        <div className="igme-hero-content">
          <h1 className="igme-hero-title">
            IGBT Modules: The Power Behind Modern Electronics
          </h1>
          <hr className="igme-hero-divider" />
          <p className="igme-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="igme-breadcrumb" aria-label="Breadcrumb">
        <div className="igme-breadcrumb-inner">
          <a href="/" className="igme-bc-item">Home</a>
          <span className="igme-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="igme-bc-item">News &amp; Updates</a>
          <span className="igme-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="igme-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="igme-main-section">
        <div className="igme-inner">
          <div className="igme-main-row">

            {/* ── ARTICLE ── */}
            <article className="igme-article">

              {/* Meta bar */}
              <div className="igme-meta-bar">
                <span className="igme-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="igme-meta-item"><img src={CalendarIcon} alt="date" /> May 3, 2025</span>
                <span className="igme-meta-item"><img src={ClockIconImg} alt="time" /> 3:41 am</span>
                <span className="igme-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="igme-article-title">
                IGBT Modules: The Power Behind Modern Electronics
              </h1>

              {/* Body */}
              <div className="igme-article-body">

                <span className="igme-h2">What Are IGBT Modules?</span>

                <p>An IGBT module is a type of power semiconductor device that efficiently manages high voltages and currents in power electronic systems. It combines the input characteristics of MOSFETs with the output capabilities of bipolar junction transistors (BJTs), offering the best of both technologies: fast switching speeds and low conduction losses.</p>

                <p>These modules are highly suitable for high power applications like motor control, solar inverters, chopper circuit converters, and AC-DC power supplies. By integrating several insulated gate bipolar transistors (IGBTs) into one unit, engineers can simplify switch configurations while maintaining high performance.</p>

                <p><strong>IGBT</strong> modules might not be the flashiest components, but they're doing some seriously heavy lifting behind the scenes. From driving electric vehicles to powering solar and wind energy systems, and keeping industrial automation and UPS systems running without a hitch—they're at the heart of high-performance power control. What makes them stand out? Their ability to handle high voltage and current with remarkable efficiency, all while keeping systems cool and reliable. Whether you're aiming to cut energy losses, boost performance, or extend the lifespan of your equipment, tapping into the full potential of IGBT modules can make all the difference.</p>

                {/* Article image */}
                <img className="igme-article-img" src={ArticleImg} alt="IGBT Modules The Power Behind Modern Electronics" />

                <span className="igme-h2">How Do IGBT Modules Work?</span>

                <p>IGBT modules operate by controlling the flow of current between their collector and emitter terminals using a voltage applied to the gate. When the gate voltage reaches a threshold, the device conducts, allowing electrical current to pass with minimal resistance. This combination of characteristics is key in applications involving high voltages and currents rapidly and reliably.</p>

                <p>The core of an IGBT module's effectiveness lies in its ability to act as a single switch or part of a full inverter design. Thanks to their high efficiency and thermal performance, engineers can design circuits with highly reliable performance even under stringent thermal and ambient conditions.</p>

                <span className="igme-heading">Key Features and Benefits of IGBT Modules</span>

                <p>Here's why IGBT power modules are favored in modern electronic design:</p>

                <ul>
                  <li><span><strong>High Efficiency:</strong> IGBT modules minimize power losses, making them suitable for power supplies, UPS systems, and electric vehicle inverters where energy efficiency is critical.</span></li>
                  <li><span><strong>Precise Switching:</strong> They feature fast switching speeds and low switching frequencies, enabling precise control of electric motors, solar inverters, and power conversion systems.</span></li>
                  <li><span><strong>Compact and Lightweight Design:</strong> These modules offer compact design at stable voltage drops, resulting in reduced heat generation and less need for extensive heat dissipation.</span></li>
                  <li><span><strong>Robust Voltage and Current Ratings:</strong> With higher breakdown voltages reaching up to 6.5kV, modern IGBT modules are ideal for industrial and transportation systems like automotive powertrains and industrial power grid control.</span></li>
                  <li><span><strong>Flexible Configuration:</strong> From single switch to chopper and dual-in-stack models, IGBT devices offer versatile switch configurations for both single-phase and three-phase systems.</span></li>
                </ul>

                <span className="igme-heading">Types of IGBT Modules</span>

                <p>Different configurations support a range of applications:</p>

                <ul>
                  <li><span><strong>Single IGBT Modules:</strong> Basic IGBT module with one transistor requiring a single switch. Commonly used in small inverters and consumer-grade inverters.</span></li>
                  <li><span><strong>Dual IGBT Modules:</strong> Two transistors with shared emitters; these are often used in chopper dual setups, perfect for motor drives with excellent user control.</span></li>
                  <li><span><strong>Six-Pack IGBT Modules:</strong> A common solution for three-phase systems. These modules include six IGBTs in a single package and are widely used in motor drives, inverters, and high-power AC-DC converters.</span></li>
                </ul>

                <span className="igme-h2">Applications of IGBT Power Modules</span>

                <p>IGBT modules power many critical technologies across industries:</p>

                <span className="igme-h2">Electric Vehicles (EVs)</span>

                <p>Used in powertrains, battery management systems, and AC-DC power supplies, enabling efficient propulsion and regenerative braking.</p>

                <span className="igme-h2">Renewable Energy Systems</span>

                <p>IGBT modules are central to solar inverters, wind turbine converters, and DC conversion systems where high voltage switching is necessary.</p>

                <span className="igme-h2">Industrial Automation</span>

                <p>From motor control in robotics to high-performance variable frequency drives (VFDs), IGBT modules ensure high efficiency and low switching losses in industrial systems.</p>

                <span className="igme-h2">Uninterruptible Power Supplies (UPS)</span>

                <p>In data centers and hospitals, IGBT power modules provide reliable backup and voltage regulation.</p>

                <span className="igme-h2">Railway and Transportation</span>

                <p>IGBT modules are key to high-power traction systems, powering electric locomotives and metro rail systems with stable, highly reliable control.</p>

                <span className="igme-heading">How to Choose the Right IGBT Module</span>

                <p>When selecting the ideal module, consider:</p>

                <ul>
                  <li><span><strong>Voltage Rating:</strong> Ensure the module can handle the input voltage and blocking voltage demands.</span></li>
                  <li><span><strong>Current Rating:</strong> Match it with your load's requirements for optimal performance.</span></li>
                  <li><span><strong>Switching Frequency:</strong> Higher frequencies require modules that fit switching characteristics.</span></li>
                  <li><span><strong>Thermal Performance:</strong> Proper heat sinks or cooling systems are crucial to extending lifespan.</span></li>
                  <li><span><strong>Application Type:</strong> Choose configurations that match your switching regulator or converter topology.</span></li>
                </ul>

                <span className="igme-heading">FAQs About IGBT Modules</span>

                <span className="igme-h2">Q: What is the lifespan of an IGBT module?</span>

                <p>A: Depending on usage, temperature, and stress levels, an IGBT module can last 10–20 years. Proper thermal management is vital for longevity.</p>

                <span className="igme-h2">Q: How do I test an IGBT module?</span>

                <p>A: Use a multimeter to check for voltage drops across terminals and continuity between gate and emitter to detect open or short circuits.</p>

                <span className="igme-h2">Q: Why do IGBT modules fail?</span>

                <p>A: Common failure reasons include thermal overload, short circuits, or incorrect switch configuration. Preventive design and regular inspections reduce failure rates.</p>

                <span className="igme-h2">Q: Can MOSFETs replace IGBT modules?</span>

                <p>A: MOSFETs are better for low-voltage, high-frequency applications. IGBT modules are more efficient for high-current, high-voltage operations.</p>

                <span className="igme-h2">IGBT Modules vs. Other Power Modules</span>

                <div className="igme-table-wrapper">
                  <table className="igme-table">
                    <thead>
                      <tr>
                        <th>Feature</th>
                        <th>IGBT Modules</th>
                        <th>MOSFET Modules</th>
                        <th>Thyristor Modules</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Voltage Range</td>
                        <td>High (Up To 6.5kV)</td>
                        <td>Low To Medium</td>
                        <td>High (Up To 6kV)</td>
                      </tr>
                      <tr>
                        <td>Switching Speed</td>
                        <td>Moderate</td>
                        <td>Very Fast</td>
                        <td>Slow</td>
                      </tr>
                      <tr>
                        <td>Efficiency</td>
                        <td>High</td>
                        <td>Very High At Low Voltages</td>
                        <td>Low</td>
                      </tr>
                      <tr>
                        <td>Applications</td>
                        <td>EVs, Solar, Industry</td>
                        <td>Low-Voltage Power Supplies</td>
                        <td>High-Power AC Control</td>
                      </tr>
                      <tr>
                        <td>Switching Losses</td>
                        <td>Low</td>
                        <td>Very Low</td>
                        <td>High</td>
                      </tr>
                      <tr>
                        <td>Best Use Case</td>
                        <td>High Power &amp; Voltage</td>
                        <td>Fast Switching, Low Power</td>
                        <td>Industrial AC Loads</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span className="igme-h2">Top Brands and Where to Buy IGBT Modules</span>

                <p>One of the top choices for highly reliable and efficient IGBT modules is <a href="/ador-powertron" className="igme-red-link-plain">Ador Powertron</a> . Their range of IGBT power modules supports advanced applications in solar energy, electric vehicles, industrial motor drives, and UPS systems. Their commitment to performance, durability, and customer satisfaction makes them a trusted name in power semiconductor solutions.</p>

                <span className="igme-h2">Final Thoughts: Why IGBT Modules Are Essential for the Future of Power Electronics</span>

                <p>As global industries shift toward smarter, more energy-efficient systems, IGBT modules continue to play a pivotal role in shaping the future of power electronic design. Their unique blend of high efficiency, high voltage tolerance, and fast switching capability make them the go-to component for cutting-edge applications in transport, energy, and automation.</p>

                <span className="igme-h2">Need Help Selecting the Right IGBT Module?</span>

                <p>Whether you're designing an EV system, optimizing a solar inverter, or building an industrial control system, the right IGBT power module is key to achieving your performance goals.</p>

                <p><a href="/contact" className="igme-red-link">Contact Us Today</a> for expert advice or to request a quote on our customizable power solutions.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="igme-bottom-row">
                <div className="igme-bottom-nav">
                  <a href="/news/previous" className="igme-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="igme-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="igme-share-icons">
                  <a href="#" className="igme-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="igme-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="igme-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="igme-sidebar">

              {/* Recent Posts */}
              <div className="igme-sidebar-block">
                <p className="igme-sidebar-title">Recent Posts</p>
                <div className="igme-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="igme-recent-item">
                      <img src={post.img} alt={post.title} className="igme-recent-img" />
                      <div className="igme-recent-body">
                        <span className="igme-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="igme-sidebar-block">
                <p className="igme-sidebar-title">Social Media</p>
                <div className="igme-social-icons">
                  <a href="#" className="igme-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="igme-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}